<template>
  <DocumentList
    document-type="published"
    meta-name="Published"
  />
</template>

<script>
import { mapActions } from 'pinia';
import { useAppBase } from '@/stores/app/base';
import { useFilters } from '@/stores/filters/filters';
import DocumentList from '../DocumentList.vue';

export default {
  name: 'PublishedList',
  components: {
    DocumentList,
  },
  emits: ['track-page-load'],
  mounted() {
    this.showFilterBarSettings({ route: this.$route.name });
    this.$emit('track-page-load', { page: 'Library: Published' });
    this.setFilterConfig({
      showMyJobs: true,
    });
  },
  methods: {
    ...mapActions(useAppBase, ['showFilterBarSettings']),
    ...mapActions(useFilters, ['setFilterConfig']),
  },
};
</script>
